import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/event/importer/eventImporterSelectors';
import EventService from 'src/modules/event/eventService';
import fields from 'src/modules/event/importer/eventImporterFields';
import { i18n } from 'src/i18n';
import { getTemplateUrl, getLatestTemplateInfo } from 'src/utils/templateUtils';

const eventImporterActions = importerActions(
  'EVENT_IMPORTER',
  selectors,
  EventService.import,
  fields,
  getLatestTemplateInfo().filename,
  10,  
  EventService.preprocessBeforeImport,
  EventService.preDownloadTemplate,
  EventService.preprocessBeforeImportExcel,
  getTemplateUrl()
);

export default eventImporterActions;
